export enum REACTION {
  THUMBS_UP = 'Thumbs Up',
  THUMBS_DOWN = 'Thumbs Down',
  NEUTRAL = 'Neutral',
}
